import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoutes from "./routes/protected-routes";
import PublicRoutes from "./routes/public-route";
import { protectedRoutes, publicRoutes } from "./routes/routes";
import "./App.css";
import NotFound from "./components/not-found";

function App() {
console.log('console added for testing')

  return (
    <Router>
      <Routes>
        <Route path="*" element={<NotFound />} />

        <Route path="/" element={<ProtectedRoutes />}>
          {protectedRoutes.map((route) => {
            return (
              <Route key={route.path} path={route.path} element={route.component} />
            );
          })}
        </Route>

        {publicRoutes.map((route) => {
          return (
            <Route key={route.path} path={route.path} element={<PublicRoutes />}>
              <Route path={`/${route.path}`} element={route.component} />
            </Route>
          );
        })}
      </Routes>
    </Router>
  );
}

export default App;
